import {
  AppDownload,
  Banner,
  CallHighlights,
  PreSales,
  Subheader,
  Warranty
} from '@/src/components/OrkaCare'

import Footer from '@/src/components/Footer/Footer2'
import Header from '@/src/components/HeaderV2'
import { Stack } from '@mui/material'
import dynamic from 'next/dynamic'
import styles from './styles.module.scss'
import { useState } from 'react'

const AfterSales = dynamic(
  () => import('@/src/components/OrkaCare/AfterSales'),
  { ssr: false }
)
const CareTeam = dynamic(() => import('@/src/components/OrkaCare/CareTeam'), {
  ssr: false
})

const OrkaCare = () => {
  const [highlightsHeight, setHighlightsHeight] = useState(0)

  return (
    <Stack>
      <Header className={styles.header} />
      <Subheader />
      <Banner storedHeight={highlightsHeight} onResize={setHighlightsHeight} />
      <CallHighlights />
      <AppDownload />
      <Footer />
    </Stack>
  )
}

export default OrkaCare
